import { IIncentiveV2Store } from "@/domain/dto/store.incentive-v2.interfaces";
import { AuthenticationProviderType } from "@/domain/enums/authentication-provider-type";
export default class EmailRegistration {
	constructor(public store: IIncentiveV2Store) {
	}


	public register(): Promise<void> {
		return this.store.actions.register({
			provider: AuthenticationProviderType.DIRECT,
			email: this.store.getters.email() ?? "",
			password: this.store.getters.password() ?? "",
			name: this.store.getters.name() ?? undefined,
			captcha: this.store.captcha.captcha!,
		});
	}
}